import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Link } from 'gatsby';

import BackToTop from '../components/BackToTop';
import Button from '../components/Button';
import ButtonSecondary from '../components/ButtonSecondary';
import DealerContainer from '../components/DealerContainer';
import ParentTemplate from '../components/ParentTemplate';
import SelectState from '../components/SelectState';
import Text from '../components/Text';

import { StyledUl, StyledArrow } from './styles';
import { mixins } from '../settings';




class DealerListTemplate extends Component {
  static propTypes = {
    pageContext: PropTypes.shape({})
  };

  static defaultProps = {
    pageContext: {}
  };

  componentDidMount() {
    let dataLayerObject = {
      dataLayerVersion: '1.0',
      page: {
        pageInfo: {
          pageName: 'nissanusa|seo_dealer_index|dealer_list',
          theme: 'Legacy|seo_index_page'
        },
        category: {
          pageType: 'html',
          hierarchy1: 'nissanusa',
          hierarchy2: 'seo_dealer_index',
          hierarchy3: 'dealer_list',
          siteSection: 'seo',
          genPageName: 'seo_dealer_index_dealer_list'
        }
      },
      event: {
        dropdown: {
          name: 'dealer-state-filter',
          value: null
        }
      }
    };
    window.dtmTrackingDataLayer = dataLayerObject;
    window.googleDataLayer = [window.dtmTrackingDataLayer, { event: 'DLready' }]
  }

  dealerDetails(dealerName){
    let dealerDtm = {
      name: dealerName,
      action: 'dealer-details'
    }
    if (typeof _satellite !== 'undefined') {
      window.dtmTrackingDataLayer.event.interaction = dealerDtm;
      _satellite.track('dtmInteraction');
    }
    
  }


  render() {
    const { pageContext } = this.props;

    const dealers = mixins.sortDealersAlpha(pageContext.data);
    const stateName = pageContext.stateName;
    const stateURL = pageContext.stateURL;

    return (
      <ParentTemplate divId="dealer-list">
        <div>
          <Helmet>
            <title>Nissan Dealers In {stateName} | Nissan USA</title>
            <meta
              name="description"
              content={`Nissan USA Official Site: See all Nissan dealers in ${stateName}, or find the ${stateName} dealership nearest you.`}
            />
            <link rel="canonical" href={`https://www.nissanusa.com/nissandealers/location/${stateURL}/`} />
          </Helmet>
          <Text.H1 transform="uppercase">{dealers ? dealers.length : 0} Nissan Dealers in {stateName}</Text.H1>


          <SelectState stateURL={stateURL} />
          {dealers ? (
            <StyledUl className="styled-ui">
              {dealers.map((dealer) => {
                const cityUrl = mixins.formatURL(dealer.dealerCityName);

                return (
                  <li key={`${dealer.dealerName}-${dealer.dealerCityName}`}>
                    <DealerContainer
                      city={dealer.dealerCityName}
                      dealer={dealer.dealerName}
                      phone={dealer.dealerPhoneNumber}
                      addressLine1={dealer.dealerAddressLine1}
                      addressLine2={dealer.dealerAddressLine2}
                      addressLine3={`${dealer.dealerCityName}, ${dealer.dealerStateCode} ${dealer.dealerZip}`}
                      award={dealer.isDealerOwnerFirst === 'true'}
                      awardImage={dealer.owner_first_image}
                      dealerWebsite={dealer.dealerWebsite}
                      dealerSEOName={dealer.dealerSEOName}
                      cityUrl={cityUrl}
                      stateURL={stateURL}
                    >
                      <Link to={`/${stateURL}/${cityUrl}/${dealer.dealerSEOName}/`} onClick={() =>this.dealerDetails(dealer.dealerName)}>
                        <Button>
                          Dealer Details
                          <StyledArrow color="red" tag="span" font="icon">
                            {' '}
                          </StyledArrow>
                        </Button>
                      </Link>
                      <a target="_blank" href={dealer.dealerWebsite} dtm-track="view-dealer" dtm-track-button-type="button">
                        <ButtonSecondary>
                          Visit Dealer Website
                          <StyledArrow color="white" tag="span" font="icon">
                            {' '}
                          </StyledArrow>
                        </ButtonSecondary>
                      </a>
                    </DealerContainer>
                  </li>
                );
              })}
            </StyledUl>
          ) : (
              <Text.H3>THERE ARE NO NISSAN DEALERS IN THE STATE YOU SELECTED. PLEASE SELECT ANOTHER STATE.</Text.H3>
            )}
        </div>

        <BackToTop transform="uppercase" />
      </ParentTemplate>

    );
  }
}


export default DealerListTemplate;
